/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestToken } from "./GuestToken";
export const GuestTokenResponse = core.serialization.object({
    data: GuestToken,
});
